var render = function render(){
  var _vm$dashboardEscolaUn, _vm$dashboardEscolaUn2, _vm$dashboardEscolas$, _vm$dashboardEscolas, _vm$dashboardEscolas$2, _vm$dashboardEscolas$3, _vm$dashboardEscolas2, _vm$dashboardEscolas3, _vm$dashboardEscolas$4, _vm$dashboardEscolas4, _vm$dashboardEscolas5, _vm$dashboardEscolas$5, _vm$dashboardEscolas6, _vm$dashboardEscolas7, _vm$dashboardEscolas$6, _vm$dashboardEscolas8, _vm$dashboardEscolas9;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('v-form', {
    ref: "form"
  }, [_c('p', [_vm._v("Buscar Por:")]), _c('v-row', {
    staticClass: "justify-start mt-3 ml-3"
  }, [_c('v-col', {
    attrs: {
      "cols": 12
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "GRE",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "return-object": "",
      "items": _vm.form.listaGerenciasRegionais
    },
    on: {
      "change": _vm.atualizarGreIds
    },
    model: {
      value: _vm.form.filters.gre,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "gre", $$v);
      },
      expression: "form.filters.gre"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": 12
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Escola",
      "dense": "",
      "outlined": "",
      "item-text": "nome",
      "item-value": "codigo",
      "return-object": "",
      "disabled": !_vm.form.filters.gre,
      "items": _vm.form.listaEscolas
    },
    model: {
      value: _vm.form.filters.escola,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "escola", $$v);
      },
      expression: "form.filters.escola"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "btn-group"
  }, [_c('v-col', {
    staticClass: "text-end"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Limpar ")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.buscarDashboard
    }
  }, [_vm._v(" Buscar ")])], 1)], 1)], 1), _c('div', {
    staticClass: "mt-7"
  }, [_vm.dashboardEscolaUnica ? _c('DashboardFormacaoEscolaUnica', {
    key: ((_vm$dashboardEscolaUn = _vm.dashboardEscolaUnica) === null || _vm$dashboardEscolaUn === void 0 ? void 0 : _vm$dashboardEscolaUn.id) || ((_vm$dashboardEscolaUn2 = _vm.dashboardEscolaUnica) === null || _vm$dashboardEscolaUn2 === void 0 ? void 0 : _vm$dashboardEscolaUn2.codigo) || JSON.stringify(_vm.dashboardEscolaUnica),
    attrs: {
      "dashboardEscolaUnica": _vm.dashboardEscolaUnica
    }
  }) : _vm._e()], 1), _vm.dashboardEscolas != null ? _c('div', {
    staticClass: "mt-7"
  }, [!_vm.dashboardEscolaUnica ? _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Escolas")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboardEscolas$ = (_vm$dashboardEscolas = _vm.dashboardEscolas) === null || _vm$dashboardEscolas === void 0 ? void 0 : (_vm$dashboardEscolas$2 = _vm$dashboardEscolas.info) === null || _vm$dashboardEscolas$2 === void 0 ? void 0 : _vm$dashboardEscolas$2.escolas) !== null && _vm$dashboardEscolas$ !== void 0 ? _vm$dashboardEscolas$ : 0))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "blue"
    }
  }, [_vm._v("mdi-bank")])], 1)])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Escolas com Formações")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboardEscolas$3 = (_vm$dashboardEscolas2 = _vm.dashboardEscolas) === null || _vm$dashboardEscolas2 === void 0 ? void 0 : (_vm$dashboardEscolas3 = _vm$dashboardEscolas2.info) === null || _vm$dashboardEscolas3 === void 0 ? void 0 : _vm$dashboardEscolas3.escolasComFormacoes) !== null && _vm$dashboardEscolas$3 !== void 0 ? _vm$dashboardEscolas$3 : 0))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "blue"
    }
  }, [_vm._v("mdi-bank")])], 1), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "blue"
    },
    on: {
      "click": _vm.openDialogListarEscolasComFormacao
    }
  }, [_vm._v("Visualizar Listagem")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Formações Realizadas")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboardEscolas$4 = (_vm$dashboardEscolas4 = _vm.dashboardEscolas) === null || _vm$dashboardEscolas4 === void 0 ? void 0 : (_vm$dashboardEscolas5 = _vm$dashboardEscolas4.info) === null || _vm$dashboardEscolas5 === void 0 ? void 0 : _vm$dashboardEscolas5.formacoesRealizadas) !== null && _vm$dashboardEscolas$4 !== void 0 ? _vm$dashboardEscolas$4 : 0))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-checkbox-marked-outline")])], 1), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "green"
    },
    on: {
      "click": _vm.openDialogListarFormacoesEscolas
    }
  }, [_vm._v("Visualizar Listagem")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Participantes")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboardEscolas$5 = (_vm$dashboardEscolas6 = _vm.dashboardEscolas) === null || _vm$dashboardEscolas6 === void 0 ? void 0 : (_vm$dashboardEscolas7 = _vm$dashboardEscolas6.info) === null || _vm$dashboardEscolas7 === void 0 ? void 0 : _vm$dashboardEscolas7.participantes) !== null && _vm$dashboardEscolas$5 !== void 0 ? _vm$dashboardEscolas$5 : 0))]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "blue"
    }
  }, [_vm._v("mdi-account-group-outline")])], 1), _c('v-btn', {
    attrs: {
      "outlined": "",
      "small": "",
      "color": "blue"
    },
    on: {
      "click": _vm.openDialogListarParticipantesEscolas
    }
  }, [_vm._v("Visualizar Listagem")])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "fill-height d-flex flex-column justify-center align-center"
  }, [_c('div', [_vm._v("Participação")]), _c('div', {
    staticClass: "d-flex justify-center align-center mt-2"
  }, [_c('div', {
    staticClass: "display-1 font-weight-bold mr-3"
  }, [_vm._v(_vm._s((_vm$dashboardEscolas$6 = (_vm$dashboardEscolas8 = _vm.dashboardEscolas) === null || _vm$dashboardEscolas8 === void 0 ? void 0 : (_vm$dashboardEscolas9 = _vm$dashboardEscolas8.info) === null || _vm$dashboardEscolas9 === void 0 ? void 0 : _vm$dashboardEscolas9.participacao) !== null && _vm$dashboardEscolas$6 !== void 0 ? _vm$dashboardEscolas$6 : 0) + " %")]), _c('v-icon', {
    attrs: {
      "large": "",
      "color": "green"
    }
  }, [_vm._v("mdi-chart-pie")])], 1)])], 1)], 1), _c('v-row', [_c('v-col', {
    staticClass: "fill-height",
    staticStyle: {
      "height": "500px"
    },
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center fill-height",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "mb-4 text-start"
  }, [_vm._v("Formações em Escolas")]), _c('PieChart', {
    attrs: {
      "chartData": _vm.dataPizza
    }
  })], 1)], 1)], 1), _c('v-row', [_vm.stackedChartData.length > 0 ? _c('v-col', {
    staticClass: "fill-height",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-card', {
    staticClass: "pa-4 text-center fill-height",
    staticStyle: {
      "height": "100%"
    }
  }, [_vm.stackedChartData ? _c('HorizontalBarStackedChart', {
    attrs: {
      "rawData": _vm.stackedChartData,
      "height": _vm.stackedChartHeight
    }
  }) : _c('p', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("Não há dados!")])], 1)], 1) : _vm._e()], 1), _c('v-row', {
    staticClass: "btn-group"
  }, [_c('v-col', {
    staticClass: "text-end"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "outlined": ""
    },
    on: {
      "click": _vm.exportarDadosPdf
    }
  }, [_vm._v(" Exportar Gráficos ")])], 1)], 1)], 1) : _vm._e()]) : _vm._e(), _vm.dialogListarEscolasComFormacaoDialog.visible ? _c('ListarEscolasComFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogListarEscolasComFormacaoDialog.visible,
      "content": _vm.dialogListarEscolasComFormacaoDialog.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarEscolasComFormacaoDialog.close();
      }
    }
  }) : _vm._e(), _vm.dialogListarFormacoesEscolas.visible ? _c('ListarFormacoesEscolasDialog', {
    attrs: {
      "visible": _vm.dialogListarFormacoesEscolas.visible,
      "content": _vm.dialogListarFormacoesEscolas.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarFormacoesEscolas.close();
      }
    }
  }) : _vm._e(), _vm.dialogListarParticipantesEscolas.visible ? _c('ListarParticipantesEscolasDialog', {
    attrs: {
      "visible": _vm.dialogListarParticipantesEscolas.visible,
      "content": _vm.dialogListarParticipantesEscolas.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogListarParticipantesEscolas.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }